import { render, staticRenderFns } from "./ClickAndBuyColorForm.vue?vue&type=template&id=429bc3de&scoped=true"
import script from "./ClickAndBuyColorForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyColorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429bc3de",
  null
  
)

export default component.exports